import { MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";
import { FormControl } from "@material-ui/core";

export default function Late() {
    const {
        late, setLate
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Tempo de Previsão: *
            </Typography>
            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setLate(e.target.value)}
                    value={late}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="true">Atendimento atrasado</MenuItem>
                    <MenuItem value="false">Atendimento em dia</MenuItem>
                </Select>
            </FormControl>
        </>
    );
}